import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import clsx from 'clsx'
import Heading from 'LuxKit/Typography/Heading'
import Caption from 'LuxKit/Typography/Caption'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'

const ItinerarySideLineWrapper = styled.div`
  position: relative;
  width: ${rem(32)};
  flex-shrink: 0;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    width: 1px;
    height: 100%;
    border-left: 1px dashed ${props => props.theme.palette.neutral.default.four};
    transform: translateX(-50%);
  }
`

const ItineraryPortContent = styled.div`
  position: relative;
  background: ${props => props.theme.palette.neutral.default.eight};
  top: ${rem(16)};
  padding: ${rem(8)} 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ItineraryPortCircle = styled.div`
  width: ${rem(32)};
  height: ${rem(32)};
  border: 2px solid ${props => props.theme.palette.neutral.default.one};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.theme.palette.neutral.default.eight};

  &.start {
    background: ${props => props.theme.palette.neutral.default.one};
  }
`

interface Props {
  portNumber: number
  isStart: boolean
  isEnd: boolean
  addPortCircle: boolean
  portName: string
}

function ItinerarySideLine({ portNumber, isStart, isEnd, addPortCircle, portName }: Props) {
  const intl = useIntl()

  return <ItinerarySideLineWrapper id={`accordion_item_${portName}`}>
    {addPortCircle && <ItineraryPortContent>
      <Caption variant="medium">
        {isStart && intl.formatMessage({
          id: 'NJuSWnvtOkglCweHUz1U',
          defaultMessage: 'Start',
          description: 'Label for the start port on cruise itinerary in the cruise section',
        })}
        {isEnd && intl.formatMessage({
          id: 'MpyVyb93BdHVRMYijSN7',
          defaultMessage: 'End',
          description: 'Label for the end port on cruise itinerary in the cruise section',
        })}
        {!isStart && !isEnd && intl.formatMessage({
          id: 'i9cgEyF10abWjyroa2em',
          defaultMessage: 'Port',
          description: 'Label for a port stop on cruise itinerary in the cruise section',
        })}
      </Caption>

      <ItineraryPortCircle className={clsx({ start: isStart })}>
        {isStart && <LineShipIcon size="S" colour="neutral-eight" />}
        {isEnd && <LineShipIcon size="S" />}
        {!isStart && !isEnd && <Heading variant="heading6">{portNumber}</Heading>}
      </ItineraryPortCircle>
    </ItineraryPortContent>}
  </ItinerarySideLineWrapper>
}

export default ItinerarySideLine
